import { render, staticRenderFns } from "./DayOfWeekPicker.vue?vue&type=template&id=2360208e&scoped=true&"
import script from "./DayOfWeekPicker.vue?vue&type=script&lang=js&"
export * from "./DayOfWeekPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2360208e",
  null
  
)

export default component.exports